
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/platformPanels/panels/deleteAppModal/deleteAppModal.scss.css.virtualfile';
        module.exports = {"delete-app-modal-root":"_delete-app-modal-root_ca2yv_7","deleteAppModalRoot":"_delete-app-modal-root_ca2yv_7"};